import type { PartnerAssetNamespace } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export type NamespaceSearchParams = {
  count?: number;
  anchor?: string;
};

export const namespaces = {
  search: {
    queryKey: 'partner-management-service/namespaces',
    configurationType: 'cached' as const,
    // A partner is capped at a small number of active namespaces server-side, so a single
    // large page returns them all; pagination is intentionally deferred.
    fn: async (params: NamespaceSearchParams = {}): Promise<PartnerAssetNamespace[]> => {
      const { data } = await GatewayAxiosClient.get<PartnerAssetNamespace[]>(
        '/partner-management-proxy/api/v1/partners/namespaces',
        { params },
      );

      return data;
    },
  },
};

/**
 * Thread an optional namespaceId onto an asset-search params object.
 *
 * Production scope is represented by `undefined`: in that case the param is omitted entirely, so
 * the request (and its react-query key) is byte-identical to the pre-namespace behavior and the
 * backend returns only production assets. A concrete namespaceId scopes the search to that
 * namespace's assets (backend semantics on every partner asset-search endpoint).
 */
export const withNamespace = <P extends object>(params: P, namespaceId?: string): P & { namespaceId?: string } =>
  namespaceId ? { ...params, namespaceId } : params;
